import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-exportfile-dropdown',
  templateUrl: './ExportFileDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => ExportFileDropdownComponent)}]
})
export class ExportFileDropdownComponent extends BaseDropdownComponent {

    constructor(private exportService: serv.ExportService) 
    { 
        super();
    }


    ngOnInit(): void {
    }

    public load(){

        this.exportService.getExportFiles().subscribe(x=> this.onGetRecordsDone(x));
    }
    
    onGetRecordsDone(items: ent.ExportFile[]){
        this.selectItems = [];
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        this.value = this.selectedID;
    }

}